import { Popover } from 'bootstrap';

export default function initPopover() {
  const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');

  popovers.forEach((el) => {
    new Popover(el, {
      trigger: 'focus',
      container: 'body'
    })
  });
}
